<div class="p-4 rounded-xl">

  <div class="flex justify-between mb-4">
    <h2 class="text-lg font-semibold">{{ 'SETUP.FIN_DATA.TITLE' | translate }}</h2>

    <button class="btn-primary" (click)="openPopup()">
      {{ 'SETUP.ADD_PLUS' | translate }}
    </button>
  </div>

  <app-table
    [columns]="columns"
    [data]="list"
    [actions]="actions"
    [pageSize]="10"
    [enablePagination]="true"
  ></app-table>

  <app-popup
    [(show)]="showPopup"
    title="SETUP.FIN_DATA.POPUP_TITLE"
    [fields]="fields"
    [data]="formData"
    [onSave]="handleSave"
    [readonly]="isViewMode"
    type="form"
  ></app-popup>

  <app-popup
    [(show)]="showDeletePopup"
    title="SETUP.FIN_DATA.DELETE_TYPE"
    type="confirm"
    [message]="deleteMessage"
    confirmText="COMMON.DELETE"
    cancelText="COMMON.CANCEL"
    (confirmed)="confirmDelete()"
  ></app-popup>

</div>